import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _toConsumableArray from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import _defineProperty from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlMixin } from '@/i18n/intl-i18n';
import IntlBreadcrumb from "../components/IntlBreadcrumb.vue";
import { getCourseLearning } from '@/api/international';
export default {
  name: 'IntlCourseLearn',
  mixins: [intlMixin],
  components: {
    IntlBreadcrumb: IntlBreadcrumb
  },
  data: function data() {
    return {
      course: null,
      selectedLanguage: '',
      chapters: [],
      selectedChapterId: null,
      completedIds: [],
      loadFailed: false
    };
  },
  computed: {
    courseTitle: function courseTitle() {
      return this.course ? this.course.title || '' : '';
    },
    courseType: function courseType() {
      return this.course ? this.course.type || this.$t('courses.defaultType') : '';
    },
    chapterTree: function chapterTree() {
      var map = {};
      var roots = [];
      this.chapters.forEach(function (chapter) {
        map[chapter.id] = _objectSpread(_objectSpread({}, chapter), {}, {
          children: []
        });
      });
      this.chapters.forEach(function (chapter) {
        if (chapter.parentId && map[chapter.parentId]) {
          map[chapter.parentId].children.push(map[chapter.id]);
        } else {
          roots.push(map[chapter.id]);
        }
      });
      return roots;
    },
    chapterList: function chapterList() {
      return this.chapterTree.reduce(function (list, chapter) {
        return list.concat(chapter, chapter.children || []);
      }, []);
    },
    selectedChapter: function selectedChapter() {
      var _this = this;
      return this.chapterList.find(function (chapter) {
        return chapter.id === _this.selectedChapterId;
      }) || null;
    },
    selectedResources: function selectedResources() {
      if (!this.selectedChapter) return [];
      if (this.selectedChapter.resourceFiles) {
        try {
          var list = JSON.parse(this.selectedChapter.resourceFiles);
          if (Array.isArray(list)) return list;
        } catch (e) {
          console.warn('resource parse failed', e);
        }
      }
      return this.selectedChapter.resourceUrl ? [{
        url: this.selectedChapter.resourceUrl
      }] : [];
    },
    selectedPosition: function selectedPosition() {
      var _this2 = this;
      return this.chapterList.findIndex(function (chapter) {
        return chapter.id === _this2.selectedChapterId;
      });
    },
    previousChapter: function previousChapter() {
      return this.selectedPosition > 0 ? this.chapterList[this.selectedPosition - 1] : null;
    },
    nextChapter: function nextChapter() {
      return this.selectedPosition >= 0 && this.selectedPosition < this.chapterList.length - 1 ? this.chapterList[this.selectedPosition + 1] : null;
    },
    progress: function progress() {
      var _this3 = this;
      if (!this.chapterList.length) return this.completedIds.length ? 100 : 0;
      var completed = this.chapterList.filter(function (chapter) {
        return _this3.completedIds.includes(chapter.id);
      }).length;
      return Math.round(completed / this.chapterList.length * 100);
    },
    progressKey: function progressKey() {
      var id = this.$route.query.id;
      return id ? "intl-course-progress:".concat(id, ":").concat(this.selectedLanguage) : '';
    }
  },
  watch: {
    '$intlLang': function $intlLang() {
      this.loadCourse();
    }
  },
  mounted: function mounted() {
    this.loadCourse();
  },
  methods: {
    loadCourse: function () {
      var _loadCourse = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, res, payload, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = this.$route.query.id;
              if (id) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              this.loadFailed = false;
              this.course = null;
              this.chapters = [];
              this.selectedChapterId = null;
              _context.prev = 2;
              _context.next = 3;
              return getCourseLearning(id);
            case 3:
              res = _context.sent;
              if (!(res.data.code !== 200)) {
                _context.next = 4;
                break;
              }
              this.loadFailed = true;
              return _context.abrupt("return");
            case 4:
              payload = res.data.data || {};
              this.course = payload.course;
              this.selectedLanguage = payload.selectedLanguage;
              this.chapters = payload.chapters || [];
              this.restoreProgress();
              this.selectedChapterId = this.chapterList.length ? this.chapterList[0].id : null;
              _context.next = 6;
              break;
            case 5:
              _context.prev = 5;
              _t = _context["catch"](2);
              console.error('loadCourse', _t);
              this.loadFailed = true;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 5]]);
      }));
      function loadCourse() {
        return _loadCourse.apply(this, arguments);
      }
      return loadCourse;
    }(),
    restoreProgress: function restoreProgress() {
      this.completedIds = [];
      if (!this.progressKey) return;
      try {
        var value = JSON.parse(localStorage.getItem(this.progressKey) || '[]');
        if (Array.isArray(value)) this.completedIds = value;
      } catch (e) {
        this.completedIds = [];
      }
    },
    saveProgress: function saveProgress() {
      if (this.progressKey) localStorage.setItem(this.progressKey, JSON.stringify(this.completedIds));
    },
    selectChapter: function selectChapter(chapter) {
      this.selectedChapterId = chapter ? chapter.id : null;
    },
    goChapter: function goChapter(chapter) {
      this.selectChapter(chapter);
      if (chapter) window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    toggleCompleted: function toggleCompleted(id) {
      this.completedIds = this.completedIds.includes(id) ? this.completedIds.filter(function (item) {
        return item !== id;
      }) : [].concat(_toConsumableArray(this.completedIds), [id]);
      this.saveProgress();
    },
    isActiveChapter: function isActiveChapter(chapter) {
      var _this4 = this;
      return this.selectedChapterId === chapter.id || (chapter.children || []).some(function (child) {
        return child.id === _this4.selectedChapterId;
      });
    },
    resourceUrl: function resourceUrl(resource) {
      return resource.ossOriUrl || resource.url || resource.resourceUrl || '';
    },
    resourceName: function resourceName(resource) {
      var url = this.resourceUrl(resource);
      return resource.fileName || resource.name || url.slice(url.lastIndexOf('/') + 1) || this.$t('common.learningResources');
    },
    resourceType: function resourceType(resource) {
      var url = this.resourceUrl(resource).toLowerCase();
      var extension = url.slice(url.lastIndexOf('.'));
      if (!/^https?:|^blob:|^data:/.test(url)) return 'other';
      if (['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg'].includes(extension)) return 'image';
      if (['.mp4', '.webm', '.ogg', '.mov'].includes(extension)) return 'video';
      if (['.mp3', '.wav', '.m4a'].includes(extension)) return 'audio';
      if (['.pdf'].includes(extension) || url.includes('docs.google.com')) return 'embed';
      return 'other';
    }
  }
};